import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const nav = [
  { path: "/", label: "Tableau de bord", icon: "🏠" },
  { path: "/supports", label: "Supports", icon: "📦" },
  { path: "/formulaires", label: "Formulaires", icon: "📋" },
  { path: "/carte", label: "Cartographie", icon: "🗺️" },
  { path: "/scanner", label: "Scanner QR", icon: "📷" },
  { path: "/rapports", label: "Rapports", icon: "📊" },
  { path: "/categories", label: "Catégories", icon: "🏷️" },
  { path: "/import", label: "Import Excel", icon: "📊" },
];

export default function Layout({ children, onLogout }) {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside style={{ width: 240, background: "#1B3A8C", color: "#fff", display: "flex", flexDirection: "column", position: "fixed", height: "100vh", zIndex: 100 }}>
        <div style={{ padding: "20px 16px", borderBottom: "1px solid rgba(255,255,255,0.1)", textAlign: "center" }}>
          <div style={{ background: "#fff", borderRadius: 8, padding: "8px", marginBottom: 8 }}>
            <img src="/logo.png" alt="OGP" style={{ height: 50, objectFit: "contain" }} onError={e => { e.target.style.display="none"; }} />
          </div>
          <div style={{ fontSize: 11, color: "#F5A800", fontWeight: 700, letterSpacing: 1 }}>RECENSEMENT DES SUPPORTS</div>
        </div>
        <nav style={{ flex: 1, padding: "12px 0" }}>
          {nav.map(n => (
            <Link key={n.path} to={n.path} style={{
              display: "flex", alignItems: "center", gap: 10, padding: "10px 20px",
              color: loc.pathname === n.path ? "#F5A800" : "rgba(255,255,255,0.8)",
              background: loc.pathname === n.path ? "rgba(245,168,0,0.1)" : "transparent",
              borderLeft: loc.pathname === n.path ? "3px solid #F5A800" : "3px solid transparent",
              textDecoration: "none", fontSize: 14, fontWeight: loc.pathname === n.path ? 600 : 400,
              transition: "all 0.2s"
            }}>
              <span>{n.icon}</span> {n.label}
            </Link>
          ))}
        </nav>
        <div style={{ padding: "16px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", marginBottom: 8 }}>
            👤 {user.username || "Utilisateur"}
          </div>
          <button onClick={onLogout} style={{
            width: "100%", padding: "8px", background: "rgba(255,255,255,0.1)",
            color: "#fff", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 6,
            cursor: "pointer", fontSize: 13
          }}>Déconnexion</button>
        </div>
      </aside>
      {/* Main */}
      <main style={{ marginLeft: 240, flex: 1, minHeight: "100vh", background: "#f5f6fa" }}>
        {children}
      </main>
    </div>
  );
}
